import React from "react";
import { getYear, getMonth } from "date-fns";
import _ from "lodash";
import IconButton from "./IconButton";
import SVG from "src/utils/SVG";
import styled from "styled-components";

interface CalenderProps {
  data: {
    date: Date;
    changeYear: any;
    changeMonth: any;
    decreaseMonth(): void;
    increaseMonth(): void;
    prevMonthButtonDisabled: boolean;
    nextMonthButtonDisabled: boolean;
  };
}

const CalendarHeader = ({ data }: CalenderProps) => {
  const years = _.range(getYear(new Date()) - 5, getYear(new Date()) + 6);
  const months = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

  return (
    <CustomHeader>
      <IconButton btnName="이전페이지" onClick={data.decreaseMonth} disabled={data.prevMonthButtonDisabled}>
        <SVG name="pageLeft" width={40} height={40} viewBox="0 0 40 40" />
      </IconButton>
      <div>
        <select value={getYear(data.date)} onChange={({ target: { value } }) => data.changeYear(value)}>
          {years.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <select value={months[getMonth(data.date)]} onChange={({ target: { value } }) => data.changeMonth(months.indexOf(value))}>
          {months.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
      <IconButton btnName="다음페이지" onClick={data.increaseMonth} disabled={data.nextMonthButtonDisabled}>
        <SVG name="pageRight" width={40} height={40} viewBox="0 0 40 40" />
      </IconButton>
    </CustomHeader>
  );
};

const CustomHeader = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("row", "space-between")}
  margin: 15px 0 10px;
  div {
    height: 40px;
    > select {
      height: 100%;
      border: none;
      background: none;
      font-size: 24px;
      text-align: center;
      &:focus {
        outline: none;
      }
    }
  }
`;

export default CalendarHeader;
